// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Hj9uT","newExpiryDate":"styles_newExpiryDate__3N3-e","footer":"styles_footer__o_5Ee"};